import { Product } from "../../enums/product";
import { ErrorMessage } from "../../enums/error-message";
import { ValidationError } from "../validation-error";
import { PascalCaseValidator } from "./pascal-case-validator";
export class CategoryValidator {
    pascalCaseValidator;
    constructor() {
        this.pascalCaseValidator = new PascalCaseValidator();
    }
    validate(trackingData) {
        const category = trackingData.category;
        if (typeof category === 'undefined') {
            throw new ValidationError(ErrorMessage.INVALID_PRODUCT);
        }
        ;
        if (!Object.values(Product).includes(category)) {
            throw new ValidationError(ErrorMessage.INVALID_PRODUCT);
        }
        this.pascalCaseValidator.validate(category);
    }
}
